import { useState } from "react"; // import state

import './globalnav.css';

export default function NavigationModal({isOpen,setOpen,modalSetLanguage,children}) {

  const [selectedValue, setSelectedValue] = useState(''); // Initial value

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    modalSetLanguage(event.target.value);
  };

  if( isOpen ) {
    return (
        <div className="globalnav-container">
          <div className="globalnav-globalnav">
            <img
              alt="image273978"
              src="/external/back-btn.svg"
              className="globalnav-image27"
              onClick={() => setOpen((prev) => !prev)}
            />
            <span className="globalnav-text12 MOBILEHEADLINE" onClick={() => setOpen((prev) => !prev)}>
                <a href="#about">ABOUT</a>
            </span>
            <span className="globalnav-text14 MOBILEHEADLINE" onClick={() => setOpen((prev) => !prev)}>
                <a href="#usage">USAGE</a>
            </span>
            <span className="globalnav-text18 MOBILEHEADLINE" onClick={() => setOpen((prev) => !prev)}>
                <a href="#ingredients">INGREDIENTS</a>
            </span>
            <span className="globalnav-text20 MOBILEHEADLINE" onClick={() => setOpen((prev) => !prev)}>
              <a href="#recycling">SORTING INFO</a>
            </span>
            <span className="globalnav-text16 MOBILEHEADLINE" onClick={() => setOpen((prev) => !prev)}>
            <a href="#production">PRODUCTION</a>
            </span>
            <span className="globalnav-text22 MOBILEHEADLINE">
              <a href="#legal">LEGAL NOTICE</a>
            </span>
            <div className="globalnav-location_selector">
              <img
                alt="globe"
                src="/external/location_globe.png"
                className="location-globe"
              />
              <select value={selectedValue} onChange={handleChange}>
                <option value="FRA">FRA</option>
                <option value="ES">SPA</option>
              </select>
            </div>
          </div>
        </div>
    );
  }

  return(children);
}